export const educationData = [
    {
        id: 0,
        institution: 'Bangladesh Open University (BOU)',
        course: 'Bachelor of Social Science [B.SS]',
        startYear: '2024',
        endYear: ''
    },
    {
        id: 1,
        institution: 'Naogaon Govt. Collage & University (NU), Naogaon',
        course: 'Bachelor of Science - Physics [B.Sc] {Hons.} [D. O.]',
        startYear: '2017',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Naogaon Govt. Collage, Naogaon',
        course: 'Higher Secondary School Certificate (HSC)',
        startYear: '2013',
        endYear: '2015'
    },
    {
        id: 3,
        institution: 'Naogaon K.D. Govt. High School, Naogaon',
        course: 'Secondary School Certificate (SSC)',
        startYear: '2010',
        endYear: '2013'
    },
    // {
    //     id: 4,
    //     institution: 'Naogaon K.D. Govt. High School, Naogaon',
    //     course: 'Junior School Certificate (JSC)',
    //     startYear: '2008',
    //     endYear: '2010'
    // },
]